import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import applySearchParams from "libs/applySearchParams";
import Tr from "../translations/Translations";
import downloadFileWithPreloadUrl from "../libs/downloadFileWithPreloadUrl";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "../constants/DemandValidation";
import moment from "libs/moment";
import isResponseValid from "../libs/isResponseValid";

const OFFER_CHOICE_RESULT_LIST_RESOURCE_ID = 'offerChoiceResultList';

const getChoiceResultList = async (demandId, pagination, search) => {
    const params = {
        ...pagination
    };
    applySearchParams(search, params);
    try {
        const resp = await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT(demandId), {params});
        reduxStore.dispatch(setResource(OFFER_CHOICE_RESULT_LIST_RESOURCE_ID, resp));
    } catch (error) {
    }
};

const setChoiceResult = (roundResult) => {
    const {resources} = reduxStore.getState();
    const curList = resources?.[OFFER_CHOICE_RESULT_LIST_RESOURCE_ID];
    if (curList) {
        const newList = {
            ...curList,
            items: curList.items.map(x => x.identity === roundResult.identity ? roundResult : x)
        }
        reduxStore.dispatch(setResource(OFFER_CHOICE_RESULT_LIST_RESOURCE_ID, newList));
    }
};

const getChoiceResultFilesList = async (demandId, roundResultId) => {
    try {
        return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_FILE(demandId, roundResultId));
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
};

const getChoiceResultPrint = async (demandId, roundResultId) => {
    try {
        await RestRequestBLOB(Endpoints.OFFER_CHOICE_RESULT_PRINT(demandId, roundResultId));
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
};

const shareChoiceResultPrint = async (demandId, roundResultId, system) => {

    try {
        const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_RESULT_SHARE(demandId, roundResultId), {system});
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
    return false;
};

const loadLastShareHistory = async (demandId, roundResultId) => {
    return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_SHARE_HISTORY_LAST(demandId, roundResultId));
};

const loadShareHistory = async (demandId, roundResultId, system) => {
    return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_SHARE_HISTORY(demandId, roundResultId, system));
};

const updatePublishUntilDate = async (demandId, roundResultId, values) => {
    try {
        const data = {
            date: values.publishUntilDate ? moment(values.publishUntilDate) : null
        };
        const resp = await RestRequestPUT(Endpoints.OFFER_CHOICE_RESULT_PUBLISH_UNTIL_DATE(demandId, roundResultId), data);
        if (resp.success) {
            const result = resp.result;
            const {resources} = reduxStore.getState();
            const list = resources[OFFER_CHOICE_RESULT_LIST_RESOURCE_ID];
            if (list) {

                const newList = {
                    ...list,
                    items: list.items.map(x => x.identity === result.identity ? {...result, positionOrders: x.positionOrders} : x)
                }
                reduxStore.dispatch(setResource(OFFER_CHOICE_RESULT_LIST_RESOURCE_ID, newList));
            }
        } else {
            console.error(resp)
            reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
};

const addChoiceResultFilesList = async (demandId, roundResultId, repositoryFiles) => {
    const data = {
        repositoryIds: repositoryFiles.map(x => x.identity)
    }

    try {
        return await RestRequestPOST(Endpoints.OFFER_CHOICE_RESULT_FILE(demandId, roundResultId), data);
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
};

const getDownloadFile = async (demandId, roundResultId, resultFileId) => {
    await downloadFileWithPreloadUrl(
        Endpoints.OFFER_CHOICE_RESULT_FILE_DOWNLOAD_URL(demandId, roundResultId, resultFileId, false),
        false);
}

const deleteFile = async (demandId, roundResultId, resultFileId) => {
    try {
        const resp = await RestRequestDELETE(Endpoints.OFFER_CHOICE_RESULT_FILE_DELETE(demandId, roundResultId, resultFileId));
        if (resp?.success && resp?.result) {
            return resp.result;
        } else {
            console.error(resp)
            reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const publishFile = async (demandId, roundResultId, resultFileId) => {
    try {
        const resp = await RestRequestPUT(Endpoints.OFFER_CHOICE_RESULT_FILE_PUBLISH(demandId, roundResultId, resultFileId));
        validateSection(DemandValidation.OFFERS_CHOICE_RESULT, demandId, false);
        return resp;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const unpublishFile = async (demandId, roundResultId, resultFileId) => {
    try {
        const resp = await RestRequestPUT(Endpoints.OFFER_CHOICE_RESULT_FILE_UNPUBLISH(demandId, roundResultId, resultFileId));
        validateSection(DemandValidation.OFFERS_CHOICE_RESULT, demandId, false);
        return resp;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

const shareFile = async (demandId, roundResultId, resultFileId, system) => {
    try {
        const resp = await RestRequestPOST(Endpoints.OFFER_CHOICE_RESULT_FILE_SHARE(demandId, roundResultId, resultFileId), {system});
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
    return false;
}

const loadFileLastShareHistory = async (demandId, roundResultId, resultFileId) => {
    return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_FILE_SHARE_HISTORY_LAST(demandId, roundResultId, resultFileId));
};

const loadFileShareHistory = async (demandId, roundResultId, resultFileId, system) => {
    return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_FILE_SHARE_HISTORY(demandId, roundResultId, resultFileId, system));
};

const getDownloadHistory = async (demandId, resultNoticeId, resultFileId, pagination) => {

    const params = {
        ...pagination
    }

    return await RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_FILE_DOWNLOAD_HISTORY(demandId, resultNoticeId, resultFileId, params), {params});
}

const validate = async (id) => {
    return RestRequestGET(Endpoints.OFFER_CHOICE_RESULT_VALIDATE(id));
}

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
};

export default {
    getChoiceResultList,
    setChoiceResult,
    getChoiceResultFilesList,
    updatePublishUntilDate,
    addChoiceResultFilesList,
    getDownloadFile,
    getChoiceResultPrint,
    shareChoiceResultPrint,
    loadLastShareHistory,
    loadShareHistory,
    deleteFile,
    publishFile,
    unpublishFile,
    getDownloadHistory,
    validate,
    clearResources,
    shareFile,
    loadFileLastShareHistory,
    loadFileShareHistory,
    OFFER_CHOICE_RESULT_LIST_RESOURCE_ID
}